import { render } from "./AddStop.vue?vue&type=template&id=88ec7086"
import script from "./AddStop.vue?vue&type=script&lang=js"
export * from "./AddStop.vue?vue&type=script&lang=js"
script.render = render

export default script